document.addEventListener('DOMContentLoaded', () => {
  const toggles = document.querySelectorAll('.submenu-toggle');
  let activeToggle = null;

  function getFocusableElements(container) {
    return container.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
  }

  function trapFocus(e, submenu) {
    const focusable = getFocusableElements(submenu);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.key === 'Tab') {
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    } else if (e.key === 'Escape') {
      closeSubmenu(activeToggle);
    }
  }

  function openSubmenu(toggle, submenu) {
    // close currently open submenu first
    if (activeToggle && activeToggle !== toggle) {
      closeSubmenu(activeToggle, { restoreFocus: false });
    }

    toggle.setAttribute('aria-expanded', 'true');
    toggle.classList.add('is-open');
    submenu.hidden = false;
    submenu.style.display = 'block';
    activeToggle = toggle;

    // move focus to first submenu item
    const focusable = getFocusableElements(submenu);
    if (focusable.length) focusable[0].focus();

    submenu.addEventListener('keydown', (e) => trapFocus(e, submenu));

    // add outside click handler
    document.addEventListener('click', handleOutsideClick);
  }

  function closeSubmenu(toggle, { restoreFocus = true } = {}) {
    if (!toggle) return;
    const menuId = toggle.getAttribute('aria-controls');
    const submenu = document.getElementById(menuId);

    toggle.setAttribute('aria-expanded', 'false');
    toggle.classList.remove('is-open');
    submenu.hidden = true;
    submenu.style.display = 'none';

    if (restoreFocus) {
      toggle.focus();
    }

    activeToggle = null;

    document.removeEventListener('click', handleOutsideClick);
  }

  function handleOutsideClick(e) {
    if (!activeToggle) return;
    const submenu = document.getElementById(activeToggle.getAttribute('aria-controls'));
    if (!submenu.contains(e.target) && !activeToggle.contains(e.target)) {
      // don’t restore focus when closing by outside click
      closeSubmenu(activeToggle, { restoreFocus: false });
    }
  }

  toggles.forEach(toggle => {
    const menuId = toggle.getAttribute('aria-controls');
    const submenu = document.getElementById(menuId);

    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        closeSubmenu(toggle);
      } else {
        openSubmenu(toggle, submenu);
      }
    });

    const closeBtn = submenu.querySelector('.submenu-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => closeSubmenu(toggle));
    }
  });
});
